"use strict";
const COOKIE_BANNER_DELAY_MS = 2000;
let cookieBannerObserver = null;
function disconnectCookieBannerObserver() {
    cookieBannerObserver?.disconnect();
    cookieBannerObserver = null;
}
function scheduleCookieBannerReveal() {
    if (window.__cookieBannerRevealScheduled)
        return;
    window.__cookieBannerRevealScheduled = true;
    disconnectCookieBannerObserver();
    window.setTimeout(() => {
        document.documentElement.classList.add('cookie-banner-ready');
    }, COOKIE_BANNER_DELAY_MS);
}
function initCookieBannerReveal() {
    const isHomepage = document.documentElement.classList.contains('is-homepage') || document.getElementById('opening-animation') != null;
    if (!isHomepage)
        return;
    window.addEventListener('opening-animation-complete', scheduleCookieBannerReveal, { once: true });
    if (window.__openingAnimationComplete) {
        scheduleCookieBannerReveal();
        return;
    }
    // Fallback when entrance-ready is set but the event was missed (e.g. early return paths).
    cookieBannerObserver = new MutationObserver(() => {
        if (document.documentElement.classList.contains('entrance-ready')) {
            scheduleCookieBannerReveal();
        }
    });
    cookieBannerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    // Never leave the banner hidden forever.
    window.setTimeout(() => {
        disconnectCookieBannerObserver();
        document.documentElement.classList.add('cookie-banner-ready');
    }, 20_000);
}
(function initOpeningAnimation() {
    const overlay = document.getElementById('opening-animation');
    if (!overlay) {
        if (document.querySelector('.homepage-header')) {
            document.documentElement.classList.add('entrance-ready');
            window.__openingAnimationComplete = true;
            window.dispatchEvent(new CustomEvent('opening-animation-complete'));
        }
        return;
    }
    const video = overlay.querySelector('video');
    if (!video) {
        window.__openingAnimationComplete = true;
        window.dispatchEvent(new CustomEvent('opening-animation-complete'));
        document.documentElement.classList.add('entrance-ready');
        return;
    }
    const skipBtn = document.getElementById('opening-animation-skip');
    const siblings = Array.from(document.body.children).filter((el) => el !== overlay && el !== skipBtn);
    siblings.forEach((el) => el.setAttribute('inert', ''));
    const removeOverlayUI = () => {
        siblings.forEach((el) => el.removeAttribute('inert'));
        skipBtn?.remove();
        overlay.remove();
    };
    let exited = false;
    function exit() {
        if (exited)
            return;
        exited = true;
        const style = getComputedStyle(overlay);
        const fadeDurationMs = Number.parseFloat(style.getPropertyValue('--fade-duration-ms') || '1000');
        const eventDelayMs = Number.parseFloat(style.getPropertyValue('--event-delay-ms') || '500');
        overlay.classList.add('is-exiting');
        if (skipBtn) {
            skipBtn.style.opacity = '0';
            skipBtn.style.pointerEvents = 'none';
        }
        setTimeout(() => {
            window.__openingAnimationComplete = true;
            window.dispatchEvent(new CustomEvent('opening-animation-complete'));
            document.documentElement.classList.add('entrance-ready');
            try {
                localStorage.setItem('oa-seen', '1');
            }
            catch {
                /* ignored */
            }
        }, eventDelayMs);
        let removed = false;
        const remove = () => {
            if (removed)
                return;
            removed = true;
            removeOverlayUI();
        };
        video.addEventListener('transitionend', remove, { once: true });
        setTimeout(remove, fadeDurationMs + 100);
    }
    if (video.ended) {
        exit();
        return;
    }
    video.addEventListener('ended', exit, { once: true });
    const triggerSkip = () => {
        if (skipBtn) {
            skipBtn.style.opacity = '0';
            skipBtn.style.pointerEvents = 'none';
        }
        overlay.classList.add('is-exiting');
        setTimeout(exit, 300);
    };
    skipBtn?.addEventListener('click', triggerSkip, { once: true });
    document.addEventListener('keydown', function onTabSkip(event) {
        if (event.key !== 'Tab' || exited)
            return;
        event.preventDefault();
        document.removeEventListener('keydown', onTabSkip);
        triggerSkip();
    });
    video.addEventListener('error', () => {
        if (exited)
            return;
        exited = true;
        removeOverlayUI();
        window.__openingAnimationComplete = true;
        window.dispatchEvent(new CustomEvent('opening-animation-complete'));
        document.documentElement.classList.add('entrance-ready');
        try {
            localStorage.setItem('oa-seen', '1');
        }
        catch {
            /* ignored */
        }
    }, { once: true });
    setTimeout(() => {
        if (!exited && video.currentTime < 0.1) {
            exit();
        }
    }, 5_000);
    setTimeout(() => {
        if (!exited) {
            exit();
        }
    }, 10_000);
})();
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBannerReveal);
}
else {
    initCookieBannerReveal();
}
